import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import ManifestContext from '@/product/context/manifest/manifestContext'
import ReportContext from '@/product/context/report/reportContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Loaders from '../../../../product/components/molecules/Loaders'
import DynamicDropdown from './DynamicDropdown'

const ManifestUpload = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [fieldValue, setFieldValue] = useState([])
    const [addInventory, setAddInventory] = useState(false)
    const [productList, setProductList] = useState([])
    const [mapArrayData, setMapArrayData] = useState([])

    const {
        uploadXLSXFile,
        getAllManifestProducts,
        // manifest_data,
        sampleXLSXFile,
        responseStatus: responseManifestUpload,
        clearResponse: clearManifestResponse,
    } = useContext(ManifestContext)
    const dynamicContext = useContext(DynamicContext)
    const { project_dynamicfields } = dynamicContext
    const {
        getXLSXFile,
        responseStatus: responseStatusReport,
        clearResponse: clearResponseReport,
    } = useContext(ReportContext)
    const data = props.data
    const toggleFullScreenPopup = props.function

    const validationArray = Yup.object({
        uploadFiles: Yup.array().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            auctiontype: 'live',
            uploadFiles: [],
            manifestUpload: true,
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            setIsLoading(true)
            let value = values
            values.withTime = true
            // value.ignoreFields = props.ignoreFields
            // values.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
            value.asinFieldMappings = props.asinFieldMappings
                ? props.asinFieldMappings
                : {}
            value.preFillFields = props.preFillFields ? props.preFillFields : {}
            value.fillIDFields = props.fillIDFields ? props.fillIDFields : []
            values.dataFields = props.dataFields ? props.dataFields : []
            values.truckload_validate = props?.truckload ? true : false
            values.skipRetailerFetch = props.skipRetailerFetch ? true : false
            value.acceptDuplicateItem = props?.acceptDuplicateItem
                ? true
                : false
            uploadXLSXFile(value)
        },
    })

    useEffect(() => {
        if (responseStatusReport?.status === 'success') {
            window.open(responseStatusReport?.data?.filePath)
        }
        clearResponseReport()
    }, [responseStatusReport])

    useEffect(() => {
        return () => {
            setIsLoading(false)
        }
    }, [])

    const formSubmit = (data) => {
        formik.values.market_status = data
        formik.submitForm().then(setIsLoading(false)).catch(setIsLoading(false))
    }

    const productListing = [
        {
            type: 'uploadDropZone',
            formik: formik,
            name: 'uploadFiles',
            titleText: 'Upload XLSX document *',
            class: 'col-12',
            folder: 'temp',
            multiple: false,
            accept: '.xlsx',
        },
    ]

    useEffect(() => {
        if (project_dynamicfields && project_dynamicfields?.length) {
            if (props?.ignoreData) {
                let dynamicValueAssign = project_dynamicfields.filter(
                    (buscat) => {
                        return (
                            (buscat.type === 'select' ||
                                buscat.type === 'multiselect') &&
                            !props.ignoreData.includes(buscat.name) &&
                            buscat.active === 1
                        )
                    }
                )
                setFieldValue(dynamicValueAssign)
            } else {
                let dynamicValueAssign = project_dynamicfields.filter(
                    (buscat) => {
                        return (
                            (buscat.type === 'select' ||
                                buscat.type === 'multiselect') &&
                            buscat.active === 1
                        )
                    }
                )
                setFieldValue(dynamicValueAssign)
            }
        }
    }, [project_dynamicfields])

    useEffect(() => {
        if (responseManifestUpload) {
            if (
                responseManifestUpload.status === 'success' &&
                responseManifestUpload.from === 'uploadXLSXFile'
            ) {
                setAddInventory(true)
                if (props.toggleManifestFullPopup) {
                    props.toggleManifestFullPopup({
                        popup: true,
                        records: responseManifestUpload.data?.records?.length
                            ? responseManifestUpload.data.records
                            : [],
                    })
                }
            }
            toggleFullScreenPopup(false)
            getAllManifestProducts({
                limit: 20,
                page: 1,
                orderby: '',
                order: '',
                filters: {
                    action: {
                        value: '',
                        type: 'in',
                        field: 'm.market_status',
                    },
                },
            })
            if (props.updateFunc) {
                props.updateFunc()
            }
            formik.setFieldValue('uploadFiles', [])
            formik.handleReset()
            setIsLoading(false)
            clearManifestResponse()
        }
    }, [responseManifestUpload])

    return (
        <FullScreenPopup
            modaltitle={`MANIFEST UPLOAD`}
            open={data.popup}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            <div className="addBulkUpload">
                <div className="fspBody">
                    {isLoading ? (
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            <form
                                onSubmit={formik.handleSubmit}
                                autoComplete="nofill"
                            >
                                <div className="row">
                                    <div className="col-md-5 col-12 mb-4">
                                        <h4 className="fspTitle">
                                            Manifest Upload Instructions
                                        </h4>
                                        <ul>
                                            <li>Download the sample file.</li>
                                            <li>
                                                Don&apos;t edit the column
                                                headers.
                                                <br />
                                                Please give appropriate values
                                                for each fields.
                                            </li>
                                            <li>
                                                Below are the mandatory fields.
                                                <ol>
                                                    {props?.requiredFields
                                                        ? props.requiredFields.map(
                                                              (data) => (
                                                                  <li>
                                                                      {data}
                                                                  </li>
                                                              )
                                                          )
                                                        : null}
                                                </ol>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-md-7 col-12">
                                        <div className="row">
                                            <div className="col-12">
                                                <h4 className="fspTitle">
                                                    Upload XLSX document
                                                </h4>
                                            </div>
                                            {Object.values(
                                                mapData(productListing)
                                            )}
                                        </div>
                                        {fieldValue?.length &&
                                        !props.noFields ? (
                                            <div className="row">
                                                <div className="col-12">
                                                    <h5 className="fspSubTitle">
                                                        Review
                                                    </h5>
                                                    <table className="table text-left">
                                                        <DynamicDropdown
                                                            arrayValue={
                                                                fieldValue
                                                            }
                                                            showWithId={
                                                                props.showWithId
                                                            }
                                                        />
                                                    </table>
                                                </div>
                                            </div>
                                        ) : null}

                                        <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                            <SecondaryButton
                                                type="button"
                                                onClick={() => sampleXLSXFile()}
                                                label="Download Sample"
                                            />
                                            <PrimaryButton
                                                onClick={() => {
                                                    formSubmit('draft')
                                                }}
                                                type="button"
                                                label="Submit"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </>
                    )}
                </div>
                <br />
            </div>
        </FullScreenPopup>
    )
}

export default ManifestUpload
